<template>
  <div class="flex w-full h-full mx-auto p-6 relative">
    <div
      class="bg-white shadow-lg rounded-lg w-2/6 mx-4 pt-4 pb-48 px-4 overflow-hidden"
      style="padding-bottom: 20rem"
    >
      <div class="flex items-center pb-4">
        <h3
          class="flex items-center font-bold text-gray-900 px-2 py-2 leading-tight tracking-wider"
        >
          Mis fichas
          <span
            class="rounded-full ml-2 border-solid border-2 border-gray-300 px-3 py-1 bg-gray-100"
            >{{ filteredRaising.length }}</span
          >
        </h3>
        <button
          class="border-2 rounded border-gray-700"
          @click="changeRaisingOrder"
          v-tooltip.right="
            'Ordena tus fichas de forma ascendente o descendente'
          "
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6 fill-current"
            viewBox="0 0 24 24"
          >
            <path
              d="M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </button>
        <button
          data-v-step="newRegister"
          class="ml-2 px-3 py-1 bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white border border-secondary-color-dark hover:border-transparent rounded"
          @click="openNewModal()"
        >
          Crear nueva ficha
        </button>
      </div>
      <input
        type="text"
        v-model="search"
        placeholder="Búsqueda de fichas"
        class="w-full appearance-none border rounded py-2 px-3 mb-1 text-gray-900 bg-gray-200 focus:outline-none focus:bg-white focus:border-teal-500"
      />
      <div class="w-full">
        <div class="w-full relative">
          <select
            class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 mb-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            name="status"
            id="status"
            v-model="categoryFilter"
            @change="updateSelectRegister()"
          >
            <option selected value="-1">Todas</option>
            <template v-for="category in categories">
              <option :key="category.id" :value="category.id">
                {{ category.nombre }}
              </option>
            </template>
          </select>
          <div
            class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
          >
            <svg
              class="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path
                d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
              />
            </svg>
          </div>
        </div>
      </div>
      <div class="w-full flex">
        <button
          v-on:click="
            (statusFilterRaising = 'TODOS'),
              filteredRaising,
              updateSelectRegister()
          "
          class="w-1/2 hover:bg-secondary-color font-semibold hover:text-white py-2 px-4 border border-secondary-color-dark hover:border-transparent rounded"
          v-bind:class="[
            statusFilterRaising === 'TODOS'
              ? 'border-transparent bg-secondary-color text-white'
              : 'bg-transparent text-secondary-color-dark',
          ]"
        >
          Total de fichas {{ filteredRaisingByAll.length }}
        </button>
        <button
          v-on:click="
            (statusFilterRaising = 'SIN EVALUAR'),
              filteredRaising,
              updateSelectRegister()
          "
          class="w-1/2 hover:bg-secondary-color font-semibold hover:text-white py-2 px-4 border border-secondary-color-dark hover:border-transparent rounded"
          v-bind:class="[
            statusFilterRaising === 'SIN EVALUAR'
              ? 'border-transparent bg-secondary-color text-white'
              : 'bg-transparent text-secondary-color-dark',
          ]"
        >
          PENDIENTES {{ filteredByChecked.length }}
        </button>
      </div>
      <div class="w-full flex">
        <button
          v-on:click="
            (statusFilterRaising = 'NO REVISADOS'),
              filteredRaising,
              updateSelectRegister()
          "
          class="w-1/2 hover:bg-secondary-color font-semibold hover:text-white py-2 px-4 border-t border-l border-b border-secondary-color-dark hover:border-transparent rounded"
          v-bind:class="[
            statusFilterRaising === 'NO REVISADOS'
              ? 'border-transparent bg-secondary-color text-white'
              : 'bg-transparent text-secondary-color-dark',
          ]"
          v-tooltip="'Fichas que enviaste para la aprobación del revisor'"
        >
          EN REVISIÓN {{ filteredRaisingByOpen.length }}
        </button>
        <button
          v-on:click="
            (statusFilterRaising = 'RECHAZADOS'),
              filteredRaising,
              updateSelectRegister()
          "
          class="w-1/2 hover:bg-secondary-color font-semibold hover:text-white py-2 px-4 border border-secondary-color-dark hover:border-transparent rounded"
          v-bind:class="[
            statusFilterRaising === 'RECHAZADOS'
              ? 'border-transparent bg-secondary-color text-white'
              : 'bg-transparent text-secondary-color-dark',
          ]"
        >
          RECHAZADAS {{ filteredRaisingByCanceled.length }}
        </button>
      </div>
      <div class="w-full flex pb-2">
        <button
          v-on:click="
            (statusFilterRaising = 'EN REVISIÓN'),
              filteredRaising,
              updateSelectRegister()
          "
          class="w-1/2 hover:bg-secondary-color font-semibold hover:text-white py-2 px-4 border-l border-r border-b border-secondary-color-dark hover:border-transparent rounded"
          v-bind:class="[
            statusFilterRaising === 'EN REVISIÓN'
              ? 'border-transparent bg-secondary-color text-white'
              : 'bg-transparent text-secondary-color-dark',
          ]"
          v-tooltip="
            'Fichas a las que el revisor hizo comentarios para que realices los cambios pertinentes y pueda ser aprobada'
          "
        >
          EN MODIFICACIÓN {{ filteredRaisingByAssigned.length }}
        </button>
        <button
          v-on:click="
            (statusFilterRaising = 'APROBADOS'),
              filteredRaising,
              updateSelectRegister()
          "
          class="w-1/2 hover:bg-secondary-color font-semibold hover:text-white py-2 px-4 border-r border-b border-secondary-color-dark hover:border-transparent rounded"
          v-bind:class="[
            statusFilterRaising === 'APROBADOS'
              ? 'border-transparent bg-secondary-color text-white'
              : 'bg-transparent text-secondary-color-dark',
          ]"
        >
          APROBADAS {{ filteredRaisingByAttended.length }}
        </button>
      </div>
      <div class="h-full overflow-auto">
        <div
          v-for="one_raising in filteredRaising"
          :key="one_raising.id"
          class="group flex items-center cursor-pointer my-1 hover:bg-gray-300 py-2 px-5 text-left"
          :class="{
            'bg-secondary-color': one_raising.id === currentRaising.id,
          }"
          @click="selectRaising(one_raising)"
        >
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              :class="[
                one_raising.id === currentRaising.id
                  ? 'text-gray-100'
                  : 'text-gray-900',
              ]"
              class="h-10 w-10 fill-current group-hover:text-gray-900 text-gray-100"
              viewBox="0 0 24 24"
            >
              <path d="M0 0h24v24H0z" fill="none" />
              <path
                d="M3 19V5H21V19ZM5 9H7V7H5ZM9 9H19V7H9ZM9 13H19V11H9ZM9 17H19V15H9ZM5 17H7V15H5ZM5 13H7V11H5Z"
              />
            </svg>
          </div>
          <div class="flex flex-col flex-grow ml-2">
            <span
              :class="[
                one_raising.id === currentRaising.id
                  ? 'text-gray-100'
                  : 'text-gray-900',
              ]"
              class="group-hover:text-gray-900"
              >{{ one_raising.title }}</span
            >
            <span
              :class="[
                one_raising.id === currentRaising.id
                  ? 'text-gray-100'
                  : 'text-gray-900',
              ]"
              class="group-hover:text-gray-900"
              >{{
                one_raising.fecha_levantamiento | moment("DD/MM/YYYY hh:mm A")
              }}</span
            >
            <span
              :class="[
                one_raising.id === currentRaising.id
                  ? 'text-gray-300'
                  : 'text-gray-700',
              ]"
              class="text-sm group-hover:text-gray-700"
              >F-{{ one_raising.id }}
              <span v-if="one_raising.status === 'EN REVISIÓN'"
                >EN MODIFICACIÓN</span
              >
              <span v-else>{{ one_raising.status }}</span>
            </span>
            <span
              :class="[
                one_raising.id === currentRaising.id
                  ? 'text-gray-300'
                  : 'text-gray-700',
              ]"
              class="text-xs group-hover:text-gray-700"
              >{{ one_raising.cat_principal }}</span
            >
            <div class="flex">
              <svg
                v-if="one_raising.ocultar_ficha"
                fill="#000000"
                height="20px"
                width="20px"
                version="1.1"
                id="Capa_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 352.644 352.644"
                xml:space="preserve"
              >
                <path
                  d="M324.478,51.943L177.985,0.285c-1.076-0.38-2.25-0.38-3.326,0L28.166,51.943c-1.999,0.705-3.337,2.595-3.337,4.715  c0,52.278,13.834,112.711,37.955,165.805c19.567,43.069,54.751,100.519,111.248,129.625c0.719,0.37,1.504,0.555,2.29,0.555  c0.786,0,1.571-0.185,2.29-0.555c56.497-29.106,91.681-86.556,111.248-129.625c24.121-53.094,37.955-113.527,37.955-165.805  C327.815,54.538,326.477,52.648,324.478,51.943z M236.322,222.07h-120c-2.549,0-4.615-2.066-4.615-4.615  c0-31.84,22.326-41.677,34.321-46.961c2.31-1.018,5.394-2.376,6.478-3.226c0.269-3.704-1.259-5.735-4.534-9.705  c-4.518-5.476-10.703-12.974-10.703-29.501c0-28.058,14.965-45.487,39.054-45.487c24.089,0,39.053,17.429,39.053,45.487  c0,16.527-6.186,24.026-10.702,29.501c-3.276,3.971-4.804,6.001-4.535,9.705c1.084,0.85,4.168,2.208,6.479,3.225  c11.994,5.285,34.321,15.121,34.321,46.962C240.937,220.003,238.871,222.07,236.322,222.07z"
                />
              </svg>
            </div>
          </div>
          <div
            v-if="one_raising.en_pausa === true"
            class="flex self-start justify-self-end text-xs"
          >
            <div
              class="px-3 py-1 rounded-full border-2 border-blue-700 text-xs text-white bg-blue-500"
            >
              En pausa
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="flex flex-wrap bg-white shadow-lg rounded-lg w-4/6 mx-4 py-8 overflow-hidden"
    >
      <div class="w-full px-4 py-2 h-full overflow-auto">
        <div class="w-full">
          <div class="flex">
            <h1
              class="pb-1 text-left font-bold tracking-widest text-neutral-100"
            >
              {{ currentRaising.cat_principal }}
            </h1>
          </div>

          <div class="w-full flex flex-wrap">
            <div class="w-full pb-2 text-right">
              <button
                v-if="currentRaising.status === 'SIN EVALUAR'"
                class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 border border-secondary-color-dark hover:border-transparent rounded"
                @click="showingCheckedConfirm = true"
              >
                Enviar a revisión
              </button>
            </div>
          </div>
          <div class="flex">
            <div class="h-80 w-full">
              <l-map
                ref="map"
                class="h-full w-full z-0"
                :zoom="zoom"
                :minZoom="4"
                :center="center"
                :options="{ zoomControl: true }"
                @ready="onMapReady"
              >
                <!-- <l-geo-json :geojson="polygon" :options-style="geoStyle" /> -->
                <l-tile-layer
                  :url="urlBasemap"
                  :attribution="attribution"
                ></l-tile-layer>
                <l-marker :lat-lng="center" :visible="showMarker"></l-marker>
              </l-map>
            </div>
          </div>
          <div class="flex w-full justify-center">
            <span
              v-if="currentRaising.status === 'APROBADO'"
              class="text-sm tracking-wide text-purple-500"
              >Ficha de registro aprobada. A partir de este momento tu ficha
              será pública para todos los usuarios, a menos de que se restrinja
              su acceso.</span
            >
            <span
              v-if="currentRaising.status === 'RECHAZADO'"
              class="text-sm tracking-wide text-purple-500"
              >Ficha de registro rechazada. Lamentamos informarte que no has
              cumplido con los requisitos mínimos para su aprobación e inclusión
              en el sitio web. Pero no te rindas, te invitamos a seguir
              intentándolo.</span
            >
          </div>
          <div class="flex w-full">
            <div
              class="flex flex-col w-8/12 px-3 py-2 mx-auto my-3 bg-gray-400 rounded-lg shadow-xl"
            >
              <div class="flex items-center">
                <div class="flex items-center w-1/2 text-left text-xs">
                  <div
                    v-if="currentRaising.status === 'NO REVISADO'"
                    class="px-3 py-1 rounded-full border-2 border-blue-700 text-white bg-blue-500 tracking-widest font-bold"
                  >
                    F-{{ currentRaising.id }} EN REVISIÓN
                  </div>
                  <div
                    v-if="currentRaising.status === 'RECHAZADO'"
                    class="px-3 py-1 rounded-full border-2 border-red-700 text-white bg-red-500 tracking-widest font-bold"
                  >
                    F-{{ currentRaising.id }} {{ currentRaising.status }}
                  </div>
                  <div
                    v-if="currentRaising.status === 'EN REVISIÓN'"
                    class="px-3 py-1 rounded-full border-2 border-orange-700 text-white bg-orange-500 tracking-widest font-bold"
                  >
                    F-{{ currentRaising.id }} EN MODIFICACIÓN
                  </div>
                  <div
                    v-if="currentRaising.status === 'APROBADO'"
                    class="px-3 py-1 rounded-full border-2 border-green-700 text-white bg-green-500 tracking-widest font-bold"
                  >
                    F-{{ currentRaising.id }} {{ currentRaising.status }}
                  </div>
                  <!-- <svg
                    class="ml-4 cursor-pointer"
                    @click="showRaisingChatModal(currentRaising)"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                  >
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path
                      d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
                    />
                  </svg> -->
                  <button
                    v-if="currentRaising.id_proyecto != null"
                    v-on:click="showProjectDetailModal()"
                    class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-1 px-4 mx-1 mt-0 border border-secondary-color-dark hover:border-transparent rounded"
                  >
                    ver proyecto
                  </button>
                </div>
                <div class="w-1/2 text-right text-xs text-gray-900">
                  {{
                    currentRaising.fecha_levantamiento
                      | moment("DD/MM/YYYY hh:mm a")
                  }}
                </div>
              </div>

              <div
                class="flex w-full text-xs pt-2 tracking-wide justify-center"
              >
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Título:</span>
                </div>
                <div
                  class="w-5/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{ currentRaising.title }}
                </div>
              </div>

              <div
                class="flex w-full text-xs pt-2 tracking-wide justify-center"
              >
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span class="font-bold">Nombre del registrante:</span>
                </div>
                <div
                  class="w-5/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{ currentRaising.nombre }} {{ currentRaising.apellido }}
                </div>
              </div>

              <div
                class="flex w-full text-xs pt-2 tracking-wide justify-center"
                v-if="currentRaising.id_curador !== null"
              >
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left"
                >
                  <span
                    class="font-bold"
                    v-if="currentRaising.status !== 'NO REVISADO'"
                    >Atendido por:</span
                  >
                </div>
                <div
                  class="w-5/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify"
                >
                  {{ currentRaising.nombre_curador }}
                  {{ currentRaising.apellido_curador }}
                </div>
              </div>

              <div
                class="flex flex-wrap w-full item-center justify-center px-3 mb-6 md:mb-0"
              >
                <template v-if="list_path_media_folder">
                  <template
                    v-for="(
                      path_media_folder, mediaIndex
                    ) in list_path_media_folder"
                  >
                    <div
                      class="w-1/2 item-center justify-center"
                      :key="mediaIndex"
                    >
                      <div class="w-full p-2">
                        <video
                          v-if="path_media_folder.mimeType == 'video/mp4'"
                          :src="replaceURL(path_media_folder.fileName, 'video')"
                          width="640"
                          height="480"
                          controls
                          controlslist="nodownload"
                        />
                        <v-lazy-image
                          v-if="
                            path_media_folder.mimeType == 'image/jpeg' ||
                            path_media_folder.mimeType == 'image/png'
                          "
                          :src="replaceURL(path_media_folder.fileName, 'img')"
                        />
                      </div>
                    </div>
                  </template>
                </template>
              </div>

              <p class="pb-1 pt-2 text-sm text-left font-bold tracking-widest">
                Ficha de información:
              </p>
              <!-- Ficha de información-->
              <div
                v-for="one_question in currentQuestions"
                :key="one_question.id"
              >
                <div v-if="one_question.texto != null">
                  <label
                    class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                    >{{ one_question.id_pregunta }}.-
                    {{ one_question.texto }}</label
                  >

                  <!-- TEMPLATE PARA PREGUNTAS DE TIPO ABIERTAS -->
                  <div v-if="one_question.tipo === 'ABIERTA'">
                    <textarea
                      v-if="one_question.tipo === 'ABIERTA'"
                      class="textareaficha appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      type="text"
                      name="question"
                      :value="one_question.respuesta"
                      disabled
                    />
                  </div>
                  <!-- /TEMPLATE PARA PREGUNTAS DE TIPO ABIERTAS -->

                  <!-- TEMPLATE PARA PREGUNTAS DE TIPO MULTISELECCION -->
                  <div v-else-if="one_question.tipo === 'MULTISELECCION'">
                    <template
                      v-for="(id_key, answer) in one_question.respuesta
                        .opciones"
                    >
                      <input
                        v-if="id_key === true"
                        class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        type="text"
                        name="question"
                        :value="answer"
                        disabled
                      />
                    </template>

                    <div
                      v-if="
                        one_question.respuesta.otro != null &&
                        one_question.respuesta.otro != ''
                      "
                      class="flex items-left text-gray-700 font-bold"
                      style="align-items: baseline"
                    >
                      Otro: &nbsp; &nbsp;
                      <input
                        class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        type="text"
                        name="question"
                        :value="one_question.respuesta.otro"
                        disabled
                      />
                    </div>

                    <template
                      v-if="
                        one_question.respuesta.hasOwnProperty('subpregunta')
                      "
                    >
                      <template
                        v-for="(answer, index) in one_question.respuesta
                          .subpregunta"
                      >
                        <label
                          class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                          >{{ answer.id_pregunta }}.- {{ answer.texto }}</label
                        >

                        <template v-if="answer.tipo == 'SELECCION'">
                          <template
                            v-if="answer.respuesta.selected_answer != 'Otro'"
                          >
                            <input
                              class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                              type="text"
                              name="question"
                              :value="answer.respuesta.selected_answer"
                              disabled
                            />
                          </template>

                          <template v-else>
                            <input
                              class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                              type="text"
                              name="question"
                              :value="
                                answer.respuesta.selected_answer +
                                ': ' +
                                answer.respuesta.otro
                              "
                              disabled
                            />
                          </template>
                        </template>

                        <template v-if="answer.tipo == 'ABIERTA'">
                          <textarea
                            class="textareaficha appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            type="text"
                            name="question"
                            :value="answer.respuesta"
                            disabled
                          />
                        </template>

                        <template v-if="answer.tipo == 'CAMPOS'">
                          <template v-for="(id_key, label) in answer.respuesta">
                            <div
                              class="flex w-full items-center justify-center"
                            >
                              <label
                                class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                                >{{ label }}</label
                              >
                              <input
                                class="appearance-none block w-9/12 bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                type="text"
                                name="question"
                                :value="id_key"
                                disabled
                              />
                            </div>
                          </template>
                        </template>
                      </template>
                    </template>
                  </div>
                  <!-- /TEMPLATE PARA PREGUNTAS DE TIPO MULTISELECCION -->

                  <!-- TEMPLATE PARA PREGUNTAS DE TIPO SELECCION_CONDICIONAL -->
                  <div
                    v-else-if="one_question.tipo === 'SELECCION_CONDICIONAL'"
                  >
                    <input
                      class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      type="text"
                      name="question"
                      :value="one_question.respuesta.selected_answer"
                      disabled
                    />

                    <template
                      v-if="
                        one_question.respuesta.conditional_answer.hasOwnProperty(
                          one_question.respuesta.selected_answer
                        )
                      "
                    >
                      <label
                        class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                        >{{
                          one_question.respuesta.conditional_answer[
                            one_question.respuesta.selected_answer
                          ].id
                        }}.-
                        {{
                          one_question.respuesta.conditional_answer[
                            one_question.respuesta.selected_answer
                          ].texto
                        }}</label
                      >

                      <template
                        v-if="
                          one_question.respuesta.conditional_answer[
                            one_question.respuesta.selected_answer
                          ].tipo == 'ABIERTA'
                        "
                      >
                        <input
                          class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                          type="text"
                          name="question"
                          :value="
                            one_question.respuesta.conditional_answer[
                              one_question.respuesta.selected_answer
                            ].respuesta
                          "
                          disabled
                        />

                        <template
                          v-if="
                            one_question.respuesta.conditional_answer[
                              one_question.respuesta.selected_answer
                            ].hasOwnProperty('subpregunta')
                          "
                        >
                          <template
                            v-for="(opt, index) in one_question.respuesta
                              .conditional_answer[
                              one_question.respuesta.selected_answer
                            ].subpregunta"
                          >
                            <label
                              class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                            >
                              {{ opt.id_pregunta }}.-
                              {{ opt.texto }}
                            </label>

                            <template v-if="opt.tipo == 'SELECCION'">
                              <input
                                class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                type="text"
                                name="question"
                                :value="opt.respuesta"
                                disabled
                              />
                            </template>
                          </template>
                        </template>
                      </template>

                      <template
                        v-if="
                          one_question.respuesta.conditional_answer[
                            one_question.respuesta.selected_answer
                          ].tipo == 'MULTISELECCION'
                        "
                      >
                        <template
                          v-for="(id_key, answer) in one_question.respuesta
                            .conditional_answer[
                            one_question.respuesta.selected_answer
                          ].respuesta.opciones"
                        >
                          <input
                            v-if="id_key === true"
                            class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            type="text"
                            name="question"
                            :value="answer"
                            disabled
                          />
                        </template>

                        <template
                          v-if="
                            one_question.respuesta.conditional_answer[
                              one_question.respuesta.selected_answer
                            ].respuesta.otro != ''
                          "
                        >
                          <input
                            class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            type="text"
                            name="question"
                            :value="
                              'Otro:' +
                              ' ' +
                              one_question.respuesta.conditional_answer[
                                one_question.respuesta.selected_answer
                              ].respuesta.otro
                            "
                            disabled
                          />
                        </template>
                      </template>

                      <template
                        v-if="
                          one_question.respuesta.conditional_answer[
                            one_question.respuesta.selected_answer
                          ].tipo == 'SELECCION'
                        "
                      >
                        <input
                          class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                          type="text"
                          name="question"
                          :value="
                            one_question.respuesta.conditional_answer[
                              one_question.respuesta.selected_answer
                            ].respuesta
                          "
                          disabled
                        />
                      </template>

                      <template
                        v-if="
                          one_question.respuesta.conditional_answer[
                            one_question.respuesta.selected_answer
                          ].tipo === 'CAMPOS'
                        "
                      >
                        <template
                          v-for="(id_key, answer) in one_question.respuesta
                            .conditional_answer[
                            one_question.respuesta.selected_answer
                          ].respuesta"
                        >
                          <div class="flex w-full items-center justify-center">
                            <label
                              class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                              >{{ answer }}</label
                            >
                            <input
                              class="appearance-none block w-9/12 bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                              type="text"
                              name="question"
                              :value="id_key"
                              disabled
                            />
                          </div>
                        </template>
                      </template>
                    </template>
                  </div>
                  <!-- /TEMPLATE PARA PREGUNTAS DE TIPO SELECCION_CONDICIONAL -->

                  <!-- TEMPLATE PARA PREGUNTAS DE TIPO SELECCION -->
                  <div v-else-if="one_question.tipo === 'SELECCION'">
                    <template
                      v-if="one_question.respuesta.selected_answer != 'Otro'"
                    >
                      <input
                        class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        type="text"
                        name="question"
                        :value="one_question.respuesta.selected_answer"
                        disabled
                      />
                    </template>
                    <template v-else>
                      <input
                        class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        type="text"
                        name="question"
                        :value="
                          one_question.respuesta.selected_answer +
                          ': ' +
                          one_question.respuesta.otro
                        "
                        disabled
                      />
                    </template>

                    <template
                      v-if="
                        one_question.respuesta.hasOwnProperty('subpregunta')
                      "
                    >
                      <template
                        v-for="(answer, index) in one_question.respuesta
                          .subpregunta"
                      >
                        <label
                          class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                          >{{ answer.id_pregunta }}.- {{ answer.texto }}</label
                        >

                        <template v-if="answer.tipo == 'SELECCION'">
                          <template
                            v-if="answer.respuesta.selected_answer != 'Otro'"
                          >
                            <input
                              class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                              type="text"
                              name="question"
                              :value="answer.respuesta.selected_answer"
                              disabled
                            />
                          </template>

                          <template v-else>
                            <input
                              class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                              type="text"
                              name="question"
                              :value="
                                answer.respuesta.selected_answer +
                                ' ' +
                                answer.respuesta.otro
                              "
                              disabled
                            />
                          </template>
                        </template>

                        <template v-if="answer.tipo == 'ABIERTA'">
                          <textarea
                            class="textareaficha appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            type="text"
                            name="question"
                            :value="answer.respuesta"
                            disabled
                          />
                        </template>

                        <template v-if="answer.tipo == 'CAMPOS'">
                          <template v-for="(id_key, label) in answer.respuesta">
                            <div
                              class="flex w-full items-center justify-center"
                            >
                              <label
                                class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                                >{{ label }}</label
                              >
                              <input
                                class="appearance-none block w-9/12 bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                type="text"
                                name="question"
                                :value="id_key"
                                disabled
                              />
                            </div>
                          </template>
                        </template>
                      </template>
                    </template>
                  </div>
                  <!-- /TEMPLATE PARA PREGUNTAS DE TIPO SELECCION -->

                  <!-- TEMPLATE PARA PREGUNTAS DE TIPO CAMPOS -->
                  <div v-else-if="one_question.tipo === 'CAMPOS'">
                    <template
                      v-for="(id_key, answer) in one_question.respuesta"
                    >
                      <div class="flex w-full items-center justify-center">
                        <label
                          class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                          >{{ answer }}</label
                        >
                        <input
                          class="appearance-none block w-9/12 bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                          type="text"
                          name="question"
                          :value="id_key"
                          disabled
                        />
                      </div>
                    </template>
                  </div>
                  <!-- /TEMPLATE PARA PREGUNTAS DE TIPO CAMPOS -->

                  <div v-else>Ninguna de las anteriores</div>
                </div>
              </div>
              <!-- /Ficha de información-->
            </div>
          </div>
        </div>
        <div>
          <button
            v-if="
              currentRaising.status === 'NO REVISADO' ||
              currentRaising.status === 'EN REVISIÓN' ||
              currentRaising.status === 'SIN EVALUAR'
            "
            v-on:click="updateTitleModal()"
            class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border border-secondary-color-dark hover:border-transparent rounded"
          >
            Editar título
          </button>
          <button
            v-if="
              (currentRaising.status === 'NO REVISADO' ||
                currentRaising.status === 'EN REVISIÓN' ||
                currentRaising.status === 'SIN EVALUAR') &&
              currentRaising.tiene_ficha == true
            "
            v-on:click="updateQuestionsModal()"
            class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border border-secondary-color-dark hover:border-transparent rounded"
          >
            Editar Ficha
          </button>
          <button
            v-if="
              (currentRaising.status === 'NO REVISADO' ||
                currentRaising.status === 'EN REVISIÓN' ||
                currentRaising.status === 'SIN EVALUAR') &&
              currentRaising.media_folder != null
            "
            v-on:click="newMediaModal()"
            class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border border-secondary-color-dark hover:border-transparent rounded"
          >
            Editar foto o video
          </button>
          <button
            v-if="
              (currentRaising.status === 'NO REVISADO' ||
                currentRaising.status === 'EN REVISIÓN' ||
                currentRaising.status === 'SIN EVALUAR') &&
              currentRaising.media_folder == null
            "
            v-on:click="newMediaModal()"
            class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border border-secondary-color-dark hover:border-transparent rounded"
          >
            Subir foto o video
          </button>
          <button
            v-if="
              currentRaising.status === 'NO REVISADO' ||
              currentRaising.status === 'EN REVISIÓN'
            "
            v-on:click="newChatModal()"
            class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border border-secondary-color-dark hover:border-transparent rounded"
          >
            Mensajes
          </button>
        </div>
      </div>
    </div>

    <user-raising-update-title-modal
      :showing="showUpdateTitleModal"
      @close="showUpdateTitleModal = false"
      @updateTitle="updateTitle($event)"
    ></user-raising-update-title-modal>

    <user-raising-update-questions-modal
      :showing="showUpdateQuestionsModal"
      @close="closeUpdateQuestionsModal()"
      @updateQuestions="updateQuestions()"
    ></user-raising-update-questions-modal>

    <user-raising-list-media-modal
      :showing="showNewMediaModal"
      @close="closeNewMediaModal()"
      @updateImage="updateImage($event)"
    ></user-raising-list-media-modal>

    <raising-chat-modal
      :showing="showCommentsModal"
      @close="closeChatModal"
    ></raising-chat-modal>

    <project-detail-modal
      :showing="showProjectDetail"
      @close="showProjectDetail = false"
    ></project-detail-modal>

    <alert-dialog :showing="showingError">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Ha ocurrido un error</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-danger-color"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingError = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingCheckedConfirm">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          ¿Realmente desea enviar a revisión el levantamiento? Esta acción no se
          puede deshacer
        </div>
      </div>
      <div class="w-full flex items-center justify-center">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-red-500 border-4 font-bold tracking-wider bg-white hover:bg-red-300"
          @click="sendCheckedProject()"
        >
          Enviar
        </button>
        <button
          class="mt-4 px-4 py-2 ml-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingCheckedConfirm = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <!-- Modal nueva ficha -->
    <div
      v-if="showingNew"
      class="fixed pt-24 pb-10 inset-0 w-full h-full flex items-center justify-center bg-semi-75 z-20"
    >
      <div
        class="mx-2 w-10/12 max-h-full h-full bg-white shadow-lg rounded-lg overflow-hidden px-4"
      >
        <div class="flex flex-col sticky top-0 bg-white pt-5">
          <div class="flex w-full justify-end mb-4">
            <button
              aria-label="close"
              class="text-xl text-gray-500"
              @click.prevent="closeNewModal"
            >
              ×
            </button>
          </div>
        </div>

        <Map />

        <div class="flex w-full sticky bottom-0 justify-end pb-5 mt-4 bg-white">
          <button
            class="ml-2 bg-purple-500 hover:bg-purple-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
            @click="closeNewModal()"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
    <!-- /Modal nueva ficha -->
  </div>
</template>

<script>
import moment from "moment";
import AlertDialog from "./AlertDialog";
/* import polygon from "../assets/polygonChapp.json"; */
import L from "leaflet";
import { LMap, LMarker, LGeoJson, LTileLayer } from "vue2-leaflet";
import * as esri from "esri-leaflet";
import { Icon } from "leaflet";
import EventBus from "../event-bus";
import UserRaisingUpdateTitleModal from "./UserRaisingUpdateTitleModal ";
import UserRaisingUpdateQuestionsModal from "./UserRaisingUpdateQuestionsModal";
import UserRaisingListMediaModal from "./UserRaisingListMediaModal";
import RaisingChatModal from "./RaisingChatModal";
import ProjectDetailModal from "./ProjectDetailModal.vue";
import Map from "./Map.vue";

export default {
  name: "user-raising-list",
  data() {
    return {
      categories: null,
      raising: [],
      currentRaising: {},
      currentQuestions: [],
      list_path_media_folder: [],
      search: "",
      raisingOrder: "downward",
      statusFilterRaising: "TODOS",
      email: localStorage.getItem("email"),
      category: localStorage.getItem("category"),
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken"),
        },
      },
      showingError: false,
      /* polygon: polygon, */
      zoom: 12,
      center: [20.58651, -89.01501],
      showMarker: false,
      geoStyle: {
        color: "#cb2833",
        fill: false,
      },
      chatRaising: null,
      chartList: null,
      showChatModal: false,
      showUpdateTitleModal: false,
      categoryFilter: "-1",
      showLevantamientoModal: false,
      showUpdateQuestionsModal: false,
      showNewMediaModal: false,
      showCommentsModal: false,
      showProjectDetail: false,
      showingCheckedConfirm: false,
      urlBasemap: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      showingNew: false,
    };
  },
  components: {
    LMap,
    LMarker,
    LGeoJson,
    LTileLayer,
    AlertDialog,
    UserRaisingUpdateQuestionsModal,
    UserRaisingListMediaModal,
    UserRaisingUpdateTitleModal,
    RaisingChatModal,
    ProjectDetailModal,
    Map,
  },
  mounted() {
    if (this.$route.query.id && this.$route.query.name) {
      let id = this.$route.query.id.toString();
      let name = this.$route.query.name.toString();
      this.search = `${id} ${name}`;
    }

    EventBus.$emit("updateNotification", {});
    this.fetchRaising();
    this.fetchCategories();
  },
  methods: {
    onMapReady: function () {
      this.$nextTick(() => {
        const map = this.$refs.map.mapObject;
        //esri.basemapLayer("Topographic").addTo(map);
      });
    },

    updateSelectRegister() {
      if (this.filteredRaising.length > 0) {
        this.selectRaising(this.filteredRaising[0]);
      }
    },

    fetchCategories() {
      this.categories = [];
      this.axios
        .get("../apidev/levantamientos/getCategorias", {}, this.config)
        .then((response) => {
          //this.categories = response.data;
          response.data.forEach((element) => {
            if (
              element.nombre != "Patrimonio material" &&
              element.nombre != "Patrimonio inmaterial"
            ) {
              this.categories.push(element);
            }
          });
        })
        .catch((error) => {
          this.catchError(error);
          this.showingError = false;
        });
    },

    fetchRaising() {
      this.$root.$emit("showLoading");
      this.axios
        .post(
          "../apidev/levantamientos/getLevantamientosDeUsuario",
          {
            email: this.email,
            category: this.category,
          },
          this.config
        )
        .then((response) => {
          this.raising = response.data.levantamientos;
          this.$root.$emit("hideLoading");
          if (this.filteredRaising.length > 0) {
            this.selectRaising(this.filteredRaising[0]);
          }
        })
        .catch((error) => {
          this.catchError(error);
          this.showingError = false;
        });
    },

    selectRaising(raising) {
      this.$root.$emit("showLoading");
      this.list_path_media_folder = [];
      this.currentRaising = raising;

      if (raising.latitud !== null && raising.longitud !== null) {
        this.center = [raising.latitud, raising.longitud];
        this.showMarker = true;
      } else {
        this.showMarker = false;
      }

      if (raising.es_notificado != null && raising.es_notificado) {
        this.axios
          .post(
            "../apidev/levantamientos/updateNotification",
            {
              id_levantamiento: this.currentRaising.id,
            },
            this.config
          )
          .then(() => {
            EventBus.$emit("updateNotification", {});
          })
          .catch((error) => this.catchError(error));
      }

      /* this.axios
        .post(
          "../apidev/levantamientos/media/list",
          {
            id: this.currentRaising.id,
          },
          this.config
        )
        .then((response) => {
          this.list_path_media_folder = JSON.parse(
            response.data.list.path_media_folder
          );
          return this.axios.post(
            "../apidev/levantamientos/getFichaRespuestasJson",
            {
              id_levantamiento: this.currentRaising.id,
            },
            this.config
          );
        })
        .then((response) => {
          this.currentQuestions = response.data.answers;
          console.log(this.currentQuestions);
          this.$root.$emit("hideLoading");
        })
        .catch((error) => {
          this.catchError(error);
          this.showingError = false;
        }); */

      this.axios
        .post(
          "../apidev/levantamientos/getFichaRespuestasJson",
          {
            id_levantamiento: this.currentRaising.id,
          },
          this.config
        )
        .then((response) => {
          this.currentQuestions = response.data.answers;
          console.log(this.currentQuestions);
          this.list_path_media_folder = JSON.parse(
            this.currentRaising.path_media_folder
          );
          this.$root.$emit("hideLoading");
        })
        .catch((error) => {
          this.catchError(error);
          this.showingError = false;
          this.list_path_media_folder = JSON.parse(
            this.currentRaising.path_media_folder
          );
          this.$root.$emit("hideLoading");
        });
    },

    changeRaisingOrder() {
      this.raisingOrder =
        this.raisingOrder === "upward" ? "downward" : "upward";
    },
    updateQuestionsModal() {
      this.showUpdateQuestionsModal = true;
      EventBus.$emit("updateQuestionsModal", {
        id: parseInt(this.currentRaising.id),
        id_project: this.currentRaising.id_proyecto,
        id_cat_principal: parseInt(this.currentRaising.id_cat_principal),
        curret_questions: this.currentQuestions,
        editQuestion: false,
      });
    },
    closeUpdateQuestionsModal() {
      this.showUpdateQuestionsModal = false;
    },
    newMediaModal() {
      this.showNewMediaModal = true;
      EventBus.$emit("newMediaModal", {
        id: parseInt(this.currentRaising.id),
      });
    },
    closeNewMediaModal() {
      this.$root.$emit("showLoading");
      this.showNewMediaModal = false;
      this.axios
        .post(
          "../apidev/levantamientos/media/list",
          {
            id: this.currentRaising.id,
          },
          this.config
        )
        .then((response) => {
          this.list_path_media_folder = JSON.parse(
            response.data.list.path_media_folder
          );
          this.$root.$emit("hideLoading");
        })
        .catch((error) => {
          this.catchError(error);
          this.showingError = false;
        });
    },
    updateQuestions() {
      this.selectRaising(this.currentRaising);
    },
    updateImage(evt) {
      this.currentRaising.path_media_folder = evt.file_path;
      this.currentRaising.file_type = evt.file_type;
    },
    updateTitleModal() {
      this.showUpdateTitleModal = true;
      let select_proyect =
        this.currentRaising.id_proyecto === null
          ? null
          : parseInt(this.currentRaising.id_proyecto);

      EventBus.$emit("updateTitle", {
        raising_id: parseInt(this.currentRaising.id),
        title: this.currentRaising.title,
        select_proyect: select_proyect,
      });
    },
    updateTitle(event) {
      this.currentRaising.title = event.title;
      this.currentRaising.id_proyecto = JSON.parse(event.id_proyecto);
    },
    newChatModal() {
      this.showCommentsModal = true;
      EventBus.$emit("showChatModal", {
        raising_id: parseInt(this.currentRaising.id),
        userficha_id: this.currentRaising.usuario_id,
        is_curador: false,
        showNewMessageButton: true,
        menu: "LEVANTAMIENTO",
      });
    },
    closeChatModal() {
      this.showCommentsModal = false;
      //this.fetchRaising();
    },
    showProjectDetailModal() {
      this.showProjectDetail = true;
      EventBus.$emit("showProjectDetail", {
        id_proyecto: this.currentRaising.id_proyecto,
      });
    },
    replaceURL(path, type) {
      if (type === "video") {
        return path.replace("./", "apidev/");
      } else {
        let lastIndex = path.lastIndexOf(".");
        let beforeStr = path.slice(0, lastIndex);
        let afterStr = path.slice(lastIndex + 1);
        let resizePath = beforeStr + "_resize." + afterStr;
        return resizePath.replace("./", "apidev/");
      }
    },
    catchError(error) {
      if (error.response.status == 400 || error.response.status == 401) {
        if (
          error.response.data.name === "TokenExpiredError" ||
          error.response.data.name === "InvalidTokenError" ||
          error.response.data.name === "JsonWebTokenError"
        ) {
          this.$router.push({ path: "/login" });
        }
      }
      this.$root.$emit("hideLoading");
    },
    joinCategories(opciones) {
      let string_categories = "";
      for (const property in opciones) {
        if (opciones[property]) {
          string_categories += property + ", ";
        }
      }

      return string_categories;
    },
    openNewModal() {
      this.showingNew = true;
    },
    closeNewModal() {
      this.showingNew = false;
      this.fetchRaising();
    },
    sendCheckedProject() {
      this.$root.$emit("showLoading");
      this.axios
        .put(
          "../apidev/levantamientos/send/checked/" + this.currentRaising.id,
          {
            user_id: localStorage.getItem("user_id"),
          },
          this.config
        )
        .then(() => {
          this.showingCheckedConfirm = false;
          this.fetchRaising();
        })
        .catch(() => {
          this.showingCheckedConfirm = false;
          this.$root.$emit("hideLoading");
          this.showingError = true;
        });
    },
  },
  computed: {
    filteredRaising() {
      return this.raising
        .filter((elem) => {
          let date = moment(elem.fecha_levantamiento).format("DD/MM/YYYY");

          let new_string_search = `${date.toLowerCase()} ${elem.id.toString()} ${elem.title.toLowerCase()}`;

          switch (this.statusFilterRaising) {
            case "TODOS":
              return (
                new_string_search.includes(this.search.toLowerCase()) &&
                (this.categoryFilter === "-1" ||
                  parseInt(elem.id_cat_principal) === this.categoryFilter)
              );
            case "RECHAZADOS":
              return (
                new_string_search.includes(this.search.toLowerCase()) &&
                elem.status == "RECHAZADO" &&
                (this.categoryFilter === "-1" ||
                  parseInt(elem.id_cat_principal) === this.categoryFilter)
              );
            case "SIN EVALUAR":
              return (
                new_string_search.includes(this.search.toLowerCase()) &&
                elem.status == "SIN EVALUAR" &&
                (this.categoryFilter === "-1" ||
                  Number(elem.id_cat_principal) ===
                    parseInt(this.categoryFilter))
              );
            case "NO REVISADOS":
              return (
                new_string_search.includes(this.search.toLowerCase()) &&
                elem.status == "NO REVISADO" &&
                (this.categoryFilter === "-1" ||
                  parseInt(elem.id_cat_principal) === this.categoryFilter)
              );
            case "EN REVISIÓN":
              return (
                new_string_search.includes(this.search.toLowerCase()) &&
                elem.status == "EN REVISIÓN" &&
                (this.categoryFilter === "-1" ||
                  parseInt(elem.id_cat_principal) === this.categoryFilter)
              );
            case "APROBADOS":
              return (
                new_string_search.includes(this.search.toLowerCase()) &&
                elem.status == "APROBADO" &&
                (this.categoryFilter === "-1" ||
                  parseInt(elem.id_cat_principal) === this.categoryFilter)
              );
            default:
              break;
          }
        })
        .sort((a, b) => {
          if (this.raisingOrder === "upward") {
            return (
              new Date(a.fecha_levantamiento) - new Date(b.fecha_levantamiento)
            );
          } else {
            return (
              new Date(b.fecha_levantamiento) - new Date(a.fecha_levantamiento)
            );
          }
        });
    },
    filteredRaisingByAll() {
      return this.raising.filter(
        (elem) =>
          this.categoryFilter === "-1" ||
          parseInt(elem.id_cat_principal) === this.categoryFilter
      );
    },
    filteredRaisingByOpen() {
      return this.raising.filter(
        (elem) =>
          elem.status == "NO REVISADO" &&
          (this.categoryFilter === "-1" ||
            parseInt(elem.id_cat_principal) === this.categoryFilter)
      );
    },
    filteredByChecked() {
      return this.raising.filter(
        (elem) =>
          elem.status == "SIN EVALUAR" &&
          (this.categoryFilter === "-1" ||
            parseInt(elem.id_cat_principal) === this.categoryFilter)
      );
    },
    filteredRaisingByAssigned() {
      return this.raising.filter(
        (elem) =>
          elem.status == "EN REVISIÓN" &&
          (this.categoryFilter === "-1" ||
            parseInt(elem.id_cat_principal) === this.categoryFilter)
      );
    },
    filteredRaisingByCanceled() {
      return this.raising.filter(
        (elem) =>
          elem.status == "RECHAZADO" &&
          (this.categoryFilter === "-1" ||
            parseInt(elem.id_cat_principal) === this.categoryFilter)
      );
    },
    filteredRaisingByAttended() {
      return this.raising.filter(
        (elem) =>
          elem.status == "APROBADO" &&
          (this.categoryFilter === "-1" ||
            parseInt(elem.id_cat_principal) === this.categoryFilter)
      );
    },

    //NO REVISADO, EN REVISION, APROBADO, RECHAZADO
  },
};
</script>

<style scoped>
textarea {
  resize: none;
}

.textareaficha {
  resize: vertical;
  text-align: justify;
  height: auto;
}

.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
